// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1zFWC","actionsCol":"EnrolledClinics_actionsCol__3nLQq"};